// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__uK0M4","title":"Header_title__ctolz","left":"Header_left__1IcyA","clinicName":"Header_clinicName__exGBZ"};